import { useQuery } from "@apollo/client";
import { useSelector } from "react-redux";

import graph from "./graph";
import Model from "./Model";
import Error from "./Error";
import Create from "./Create";
import Loading from "./Loading";

export default function UnitVerification() {
  const { userToken } = useSelector((state) => state.auth);

  const {
    data,
    error,
    loading,
    refetch: refresh,
  } = useQuery(graph.get.query, {
    pollInterval: 60000,
    context: {
      serviceName: graph.get.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const refetch = () => refresh();

  if (error) {
    return <Error error={error?.message} loading={loading} refetch={refetch} />;
  }

  if (loading) {
    return <Loading />;
  }

  const { data: unit } = data[graph.get.name];

  let userUnit = unit[0];

  // INIT_REGISTER   = 1;  // ثبت اولیه
  // REGISTERED      = 2;  // ثبت شده
  // PENDING         = 3;  // در حال بررسی
  // CONFIRMED       = 4;  // تایید شده
  // SUSPENDED       = 5;  // معلق شده

  if (userUnit) {
    userUnit = {
      ...userUnit,
      address: userUnit.address || "",
    };
    if (userUnit?.status?.id === "2") {
      if (userUnit?.media.length >= 0) {
        if (userUnit?.media.length >= 3) {
          return <Create init={userUnit} refetch={refetch} initStep={3} />;
        }
        return <Create init={userUnit} refetch={refetch} initStep={2} />;
      }
      return <Create init={userUnit} refetch={refetch} initStep={1} />;
    }
    return <Model model={userUnit} refetch={refetch} />;
  }
  return <Create init={userUnit} refetch={refetch} initStep={1} />;
}
